export default class Service {
    constructor(
        public readonly name_alias: string,
        public readonly price_alias: string,
        public readonly icon: string
    ) {}

}
